import { Link } from 'react-router-dom';
import image1 from "../../../assets/img/about/about-1.jpeg";
import image2 from "../../../assets/img/about/about-2.jpeg";

const About = () => {
    return (
        <>
            <div className="about__one section-padding">
                <div className="container">
                    <div className="row al-end">
                        <div className="col-lg-7 lg-mb-25">
                            <div className="about__one-left">
                                <div className="about__one-left-title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Welcome to Arclight Developers</span>
                                    <h2 className="wow fadeInRight" data-wow-delay=".6s">Committed to Quality-Driven Civil Development</h2>
                                </div>
                                <div className="row al-center mt-45">
                                    <div className="col-md-4 md-mb-25">
                                        <div className="about__one-left-image wow fadeInLeft" data-wow-delay=".4s">
                                            <img className="md_img_full" src={image2} alt="image" />
                                        </div>
                                    </div>
                                    <div className="col-md-8 pl-50 xl-pl-10">
                                        <div className="about__one-left-list">
                                            <p className="mb-20 wow fadeInUp" data-wow-delay=".3s" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                                Arclight Developers is committed to quality-driven civil and infrastructure development work. Under the leadership of <strong>Founder Aakash Vaghela</strong>, we focus on practical, durable, and efficient execution of public utility and development projects.
                                            </p>
                                            <p className="wow fadeInUp" data-wow-delay=".5s" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                                From RCC and damar roads to drainage, irrigation, pipeline, beautification, and renovation work, our goal is to deliver reliable results with professional standards.
                                            </p>
                                        </div>
                                        <div className="wow fadeInDown" data-wow-delay="1.2s">
                                            <Link className="build_button mt-40" to="/about-us">Discover more<i className="flaticon-right-up"></i></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="about__one-right t-right">
                                <img className="wow img_right_animation lg_img_full" src={image1} alt="image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;